(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-frk-equivalent-kits]';
  const scriptTag = document.currentScript;
  const scriptUrl = scriptTag?.dataset.frkEquivalentScript || '';
  const styleUrl = scriptTag?.dataset.frkEquivalentStyle || '';

  if (!scriptUrl || !styleUrl) return;

  const state = window.__FRK_EQUIVALENT_KITS_ASSET_LOADER__ ||= {
    loading: null,
    observed: new WeakSet()
  };

  function loadAssets() {
    if (state.loading) return state.loading;

    state.loading = new Promise((resolve, reject) => {
      if (!document.querySelector('link[data-frk-equivalent-full-style]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = styleUrl;
        link.dataset.frkEquivalentFullStyle = 'true';
        document.head.appendChild(link);
      }

      const existing = document.querySelector('script[data-frk-equivalent-full-script]');
      if (existing) {
        if (window.__FRK_EQUIVALENT_KITS_FULL_FAST_LOADED__) resolve();
        else existing.addEventListener('load', resolve, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.dataset.frkEquivalentFullScript = 'true';
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', () => reject(new Error('Unable to load equivalent-kit controls')), { once: true });
      document.head.appendChild(script);
    }).catch((error) => {
      console.error('[FRK equivalent kits loader]', error);
      state.loading = null;
    });

    return state.loading;
  }

  function observe(root) {
    if (!root || state.observed.has(root)) return;
    state.observed.add(root);

    if (!('IntersectionObserver' in window)) {
      loadAssets();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      // Phase 2 speed pass (22 Sep 2026): rootMargin reduced from 900px to
      // 300px per the brief (~250-350px), plus requestIdleCallback so the
      // fetch/parse work doesn't compete with anything still happening on
      // the main thread right as the section nears the viewport.
      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadAssets, { timeout: 1000 });
      } else {
        loadAssets();
      }
    }, { rootMargin: '300px 0px' });

    observer.observe(root);
  }

  function init(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(observe);
  }

  init();

  if (!state.sectionListenerBound) {
    state.sectionListenerBound = true;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})();
